define('controllers/newsedit',['require','nicEditlatest'],function(require) {
    require('nicEditlatest');
    return function () {
        var Description = null;

        function toggleArea() {
            try {
                if (!Description) {
                    Description = new nicEditor({ fullPanel: true }).panelInstance('TextBoxDescriptionHTML', { hasPanel: true });
                } else {
                    Description.removeInstance('TextBoxDescriptionHTML');
                    Description = null;
                }
            } catch (err) {
            }
        }

        window.onload = function () {
            toggleArea();
        }
    };
});

